import { WatchlistStatusType, WatchlistStatusTypeOptions } from '@apply/constants';

export const getWatchlistStatusName = (statusId: WatchlistStatusType): string | null => {
    const option = WatchlistStatusTypeOptions.find((a) => a.id === statusId);
    if (!option) {
        return null;
    }
    return option.name;
};
